<main id="db-wrapper" class="bg-light">
    <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
    <section id="page-content">
      <div class="header">
        <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
        <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
      </div>
      <div class="container-fluid py-5" >
        <div class="container">
         <div class="row no-gutters">
           <div class="col-lg-12">
            
            <div class="container" *ngIf="loading">
              <div class="row">
                <div class="col-lg-12">
                     <app-form-spinner></app-form-spinner>
                </div>
              </div>
            </div>
            <div class="card mb-4 p-6 mb-10" *ngIf="!loading">
              <div class="card-header">
                <h2>
                  {{"specify_email_time" | translate}}
                </h2>
              </div>
              <form  [formGroup]="form" (ngSubmit)="onSubmit()"  class="row no-gutters">
                <div class="col-lg-12 my-2">
                  <div class="form-group">
                    <label for="" class="form-label">
                      {{"delayPerEmailNotification" | translate}}
                    </label>
                    <h2>
                      Hourly
                    </h2>
                    <select class="form-select d-none" formControlName="delayNotification">
                      <option value="" > Choose any</option>
                      <option value="3">1 minute Delay</option>
                      <option value="2">2 minutes Delay</option>
                      <option value="8">8 minutes Delay</option>
                      <option value="10">10 minutes Delay</option>
                      <option value="30">30 minutes Delay</option>
                      <option value="40">40 minutes Delay</option>
                    </select>
                     <small class="text-danger" *ngIf="form.get('delayNotification')?.invalid && form.get('delayNotification')?.touched">Delay is required</small>
                  </div>
                </div>
                <div class="col-lg-12 mmy-2">
                  <div class="form-group">
                    <label for="" class="form-label"> 
                      {{"notificationFrequency1" | translate}}
                    </label>
                    <h2>
                      Daily
                    </h2>
                    <select class="form-control d-none" formControlName="notificationFrequency">
                      <option value="Daily"> Daily </option>
                      <option value="Weekly"> Weekly </option>
                      <option value="Monthly"> Monthly </option>
                    </select>
                     <small class="text-danger" *ngIf="form.get('notificationFrequency')?.invalid && form.get('notificationFrequency')?.touched">Notification Frequency is required</small>
                  </div>
                </div>
                <div class="col-lg-12 my-2">
                  <div class="form-group">
                    <label for="" class="form-label">
                      {{"notificationsPerEmail" | translate}}
                    </label>
                    <select class="form-select" formControlName="notificationsPerEmail">
                      <option value="3" selected>1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="10">10</option>
                    </select>
                     <small class="text-danger" *ngIf="form.get('notificationsPerEmail')?.invalid && form.get('notificationsPerEmail')?.touched">Notifications Per Emailis required</small>
                  </div>
                </div>
                 <div class="col-lg-12 d-grid mt-2">
                  <button type="button" class="btn btn-primary py-2  mb-2 rounded-4"   *ngIf="loading">
                    <div class="spinner-border text-light" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                 </button>
                  <button type="submit" class="btn btn-primary " type="submit"  [disabled]="form.invalid" *ngIf="!loading">Save</button>
                 </div>
              </form>
             </div>
  
           </div>
  
          </div>
        </div>
       </div>
    </section>
  </main>
  
  
 
  <div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
    <app-bottom-nav></app-bottom-nav>
  </div>